import { axiosInstance } from "../axios-instance";

const customers = "customers";

const CustomersServices = {
  getCustomers: () => axiosInstance.get(`/${customers}`),
  getCustomer: (id) => axiosInstance.get(`/${customers}/${id}`),
  storeCustomer: (payload) =>
    axiosInstance.postForm(`/${customers}/store`, payload),
  updateCustomer: (payload) =>
    axiosInstance.postForm(`/${customers}/update/${payload.id}`, payload),
  deleteCustomer: (id) => axiosInstance.delete(`/${customers}/delete/${id}`),
  searchCustomer: (payload) =>
    axiosInstance.post(`/${customers}/search`, payload),
};

export default CustomersServices;
